import angular from 'angular'

import { ListEmployeesContainerComponent } from './list-employees-container.component';
import { RosterRoutingModule } from './roster-routing.module';
import { RosterEditModule } from './edit/roster-edit.module';
import { BankAccountModule } from './bank-accounts/bank-account.module';
import { ListEmployeeRosterTableComponent } from './roster-table/list-employees-roster-table.component';
import { PendingEmployeeModalComponent } from './roster-table/pending-employee-modal.component';

export const RosterModule = angular
    .module("apex.mainApp.roster", [
        RosterEditModule,
        RosterRoutingModule,
        BankAccountModule
    ])
    .component("apexListEmployeesContainer", ListEmployeesContainerComponent)
    .component("apexListEmployeeRosterTable", ListEmployeeRosterTableComponent)
    .component("apexPendingEmployeeModal", PendingEmployeeModalComponent)
    .name
